import PropTypes from 'prop-types';

import s from './tickerHero.module.css';

function TickerHero({ text }) {
  return (
    <div className={s.ticker}>
      <p>
        {text} <span>{`//`}</span> {text} <span>{`//`}</span>
      </p>
      <p aria-hidden="true">
        {text} <span>{`//`}</span> {text} <span>{`//`}</span>
      </p>
    </div>
  );
}

export default TickerHero;

TickerHero.propTypes = {
  text: PropTypes.string.isRequired,
};
